var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mx-3"},[_c('locations-table',{attrs:{"items":this.displayedData}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72616ae2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations/Locations.vue
// module id = 2b5l
// module chunks = 0